/**
 * DÍA 7 — Descanso.
 *
 * Descanso formal. La consistencia se construye también evitando convertir el
 * plan en siete días de estudio.
 *
 * Es la ÚNICA sesión cuyos pasos no tienen tiempo (`minutosSugeridos: null`).
 * Poner un temporizador a un día de descanso sería contradecirlo.
 *
 * `areasAEvaluar` está vacío a propósito: no se autoevalúa un día de descanso.
 * Pedir puntuaciones hoy convertiría el descanso en otra tarea.
 *
 * Las tres duraciones comparten el mismo paso: el descanso no escala con el
 * tiempo disponible. Que el selector 20/35/50 siga visible es intencional —
 * la sesión existe en las tres, y contesta lo mismo en las tres.
 */

import type { Sesion } from '../../tipos.js';

const PASO_DESCANSO = {
  clave: 'd7-descanso',
  titulo: 'Descanso',
  minutosSugeridos: null,
  herramienta: 'ninguna' as const,
  objetivo: 'No hacer entrenamiento formal hoy.',
  porQue:
    'El programa tiene que ser sostenible doce semanas. La exposición recreativa es bienvenida, pero hoy no la convertimos en tarea, y no hay nada que compensar.',
  instrucciones: [
    'Hoy no hay ejercicios y no hay que recuperar nada.',
    'Si te apetece, mirá YouTube, una película, un podcast o leé algo en inglés.',
    'Sin tomar notas, sin registrar errores, sin objetivos.',
    'Si no querés exponerte al inglés hoy, tampoco pasa nada.',
  ],
  notaTiempo:
    'Este día no tiene temporizador. No hay un tiempo que cumplir ni un mínimo que alcanzar.',
};

export const D7: Sesion = {
  clave: 'd7',
  tipo: 'dia',
  etiqueta: 'Día 7 · Descanso',
  titulo: 'Día 7 · Descanso formal',
  corto: 'Descanso',
  objetivo: 'Conservar la adherencia y permitir recuperación.',
  porQue:
    'Descansar forma parte del diseño. Un programa de siete días de estudio se abandona en la semana cuatro.',
  areasAEvaluar: [],
  capturaCorrecciones: false,
  planes: {
    20: { duracion: 20, pasos: [{ ...PASO_DESCANSO }] },
    35: { duracion: 35, pasos: [{ ...PASO_DESCANSO }] },
    50: { duracion: 50, pasos: [{ ...PASO_DESCANSO }] },
  },
};
